import { render } from "./PostItem.vue?vue&type=template&id=74b38b8f&scoped=true"
import script from "./PostItem.vue?vue&type=script&lang=js"
export * from "./PostItem.vue?vue&type=script&lang=js"

import "./PostItem.vue?vue&type=style&index=0&id=74b38b8f&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Admin\\Desktop\\Ulbi\\BlogApp\\blog_app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74b38b8f"]])

export default __exports__